import mustache from "mustache";
import { ClienteFincaLoteResponse } from "../../../../../modulos/terceros/response/ClienteFincaLoteResponse";
import { _miles } from "../../../../../utils/numberUtils";
import { IRender } from "../../../../definitions/IRender";
import template from "./template.html";

mustache.parse(template);

/** Fila label/valor de la ficha de lote. */
export type LoteInfoRow = {
  /** Etiqueta del campo. */
  label: string;
  /** Valor mostrado. */
  value: string;
};

/** Ficha de lote (panel de solo lectura: nombre + filas label/valor). Reutilizable
 *  sola (sin selector). Aporta las filas comunes (Área ha/cds); las filas
 *  específicas del tipo de finca las define cada subclase en `getExtraRows`. */
export abstract class LoteInfoRender implements IRender {
  /** @param _lote Lote a mostrar. */
  constructor(protected readonly _lote: ClienteFincaLoteResponse) {}

  /** Filas específicas del tipo de finca (agricultura/ganadería). */
  protected abstract getExtraRows(): LoteInfoRow[];

  render(): string {
    const rows: LoteInfoRow[] = [
      { label: "Área (ha)", value: `${_miles(this._lote.areaHectareas)} ha` },
      { label: "Área (cds)", value: `${_miles(this._lote.areaCuadras)} cds` },
      ...this.getExtraRows(),
    ];
    return mustache.render(template, { nombre: this._lote.nombreLote, rows });
  }
}
